import { AbstractCommand } from 'src/models/command';

class DeleteTheIdoCommand extends AbstractCommand {
	override readonly async = false;
	readonly name = 'IFS_IDO_Command_Command_DeleteTheIdoCommand';

	public constructor(idoId: string, idoInstanceId: string, lastKnownChangeTimestamp: string) {
		super();
		this.parameters = {
			idoId: idoId,
			idoInstanceId: idoInstanceId,
			lastKnownChangeTimestamp: lastKnownChangeTimestamp,
		};
	}
}

export { DeleteTheIdoCommand };
